/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./js/components/product-api.js":
/*!**************************************!*\
  !*** ./js/components/product-api.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  var getSearchResult = /*#__PURE__*/function () {
    var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (productId, target) {
      var storeFrontKey = 'db7d42272d44066da050983b65537ccc';
      var url = "/api/2024-10/graphql.json";
      var shopifyHeader = new Headers();
      shopifyHeader.append("Content-Type", "application/json");
      shopifyHeader.append("X-Shopify-Storefront-Access-Token", storeFrontKey);
      var graphqlquery = {
        query: "query MyQuery {\n        product(id: \"gid://shopify/Product/".concat(productId, "\") {\n          handle\n          variants(first: 10) {\n            nodes {\n              compareAtPrice {\n                amount\n                currencyCode\n              }\n              price {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }"),
        variables: {}
      };
      var requestOptions = {
        method: 'POST',
        headers: shopifyHeader,
        body: JSON.stringify(graphqlquery)
      };
      try {
        var response = yield fetch(url, requestOptions);
        var productData = yield response.json();
        updateComparePrice(productData, target);
        return productData;
      } catch (error) {
        console.error("Error fetching search results:", error);
        return null;
      }
    });
    return function getSearchResult(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var updateComparePrice = (productData, target) => {
    var _productData$data, _variants$, _variants$2, _variants$3;
    if (!(productData !== null && productData !== void 0 && (_productData$data = productData.data) !== null && _productData$data !== void 0 && (_productData$data = _productData$data.product) !== null && _productData$data !== void 0 && (_productData$data = _productData$data.variants) !== null && _productData$data !== void 0 && _productData$data.nodes)) {
      console.warn("No variant data found for product ID: ".concat(productId));
      return;
    }
    var variants = productData.data.product.variants.nodes;
    var handle = productData.data.product.handle;
    var comparePrice = (_variants$ = variants[0]) === null || _variants$ === void 0 || (_variants$ = _variants$.compareAtPrice) === null || _variants$ === void 0 ? void 0 : _variants$.amount;
    var price = (_variants$2 = variants[0]) === null || _variants$2 === void 0 || (_variants$2 = _variants$2.price) === null || _variants$2 === void 0 ? void 0 : _variants$2.amount;
    var currencyCode = ((_variants$3 = variants[0]) === null || _variants$3 === void 0 || (_variants$3 = _variants$3.price) === null || _variants$3 === void 0 ? void 0 : _variants$3.currencyCode) || 'USD'; // Default to USD if not provided

    // Force currency to USD
    currencyCode = 'USD';
    var comparePriceElements = target.querySelectorAll("[data-compare-price-b2b]");
    var srpPriceElements = target.querySelectorAll("[data-srp-price-b2b]");
    var srpCompareElements = target.querySelectorAll(".srp-comapre__price-b2b-color");
    var productParentEl = target.closest('[data-product]');
    if (!productParentEl) {
      productParentEl = target.closest('.product-item');
    }
    var specialPriceElements = target.querySelectorAll(".special-price__hide");
    if (comparePrice) {
      var formattedComparePrice = formatPrice(comparePrice, currencyCode);
      var formattedPrice = formatPrice(price, currencyCode);
      srpPriceElements.forEach(element => {
        element.innerHTML = formattedComparePrice;
        element.style.display = 'block';
      });
      comparePriceElements.forEach(element => {
        element.innerHTML = formattedPrice;
        element.style.display = 'block';
        element.classList.add('b2b-sale-price-present');
      });
      if (productParentEl) {
        var saleTagElements = productParentEl.querySelectorAll("[data-on-sale-b2b]");
        saleTagElements.forEach(saleTagElement => {
          var saleBox = saleTagElement.querySelector('.sale-box');
          if (!saleBox) {
            saleBox = document.createElement('span');
            saleBox.classList.add('sale-box', 'tw-max-w-fit');
            saleBox.setAttribute('data-aos', 'fade');
            saleBox.setAttribute('data-aos-delay', '{{ aos_delay }}');
            saleBox.setAttribute('data-aos-duration', '{{ aos_duration }}');
            saleBox.setAttribute('data-aos-anchor', '{{ aos_anchor }}');
            saleBox.textContent = 'Sale';
            saleTagElement.appendChild(saleBox);
          }
          saleBox.style.opacity = '1';
        });
      }
      console.log("Updated compare price for product ".concat(target.entry, ": ").concat(formattedComparePrice));
    } else {
      var _formattedPrice = formatPrice(price, currencyCode);
      srpPriceElements.forEach(element => {
        element.innerHTML = _formattedPrice;
        element.style.display = 'block';
      });
      comparePriceElements.forEach(element => {
        element.style.display = 'none';
      });
      comparePriceElements.forEach(srpElement => {
        srpElement.classList.remove('b2b-sale-price-present');
      });
      specialPriceElements.forEach(element => {
        element.style.display = 'none';
      });
      console.log("No compare price found for product ".concat(target.entry, ". Showing regular price: ").concat(_formattedPrice));
    }
  };
  var formatPrice = function formatPrice(amount) {
    var currencyCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode
    });
    return formatter.format(amount);
  };
  var initSearchWithIntersectionObserver = () => {
    var targetElements = document.querySelectorAll("[data-product-card-id]");
    if (targetElements.length === 0) {
      console.warn("No product cards found with data-product-card-id attribute");
      return {
        cancel: () => {}
      };
    }
    var observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          var _productId = entry.target.dataset.productCardId;
          if (!_productId) {
            observer.unobserve(entry.target);
            return;
          }
          getSearchResult(_productId, entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    });
    targetElements.forEach(item => {
      observer.observe(item);
    });
    return {
      cancel: () => {
        observer.unobserve(targetElements);
      }
    };
  };
  initSearchWithIntersectionObserver();
});

/***/ }),

/***/ "./js/components/quantity-rule-error.js":
/*!**********************************************!*\
  !*** ./js/components/quantity-rule-error.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  var quantityInputs = document.querySelectorAll(".quantity__input");
  var addToCartButton = document.querySelector("[data-add-to-cart]");
  var quantityButtons = document.querySelectorAll(".quantity__minus, .quantity__plus");
  quantityInputs.forEach(input => {
    input.addEventListener("input", validateQuantity);
    input.addEventListener("change", validateQuantity);
  });

  // Function to validate quantity input
  function validateQuantity(event) {
    var errorContainer = document.querySelector('[data-cart-errors-container]');
    if (errorContainer && errorContainer.classList.contains('is-visible')) {
      errorContainer.classList.remove('is-visible');
    }
    var input = event.target;
    var min = parseInt(input.getAttribute("min"), 10);
    var step = parseInt(input.getAttribute("step"), 10);
    var value = parseInt(input.value, 10);
    if ((value - min) % step !== 0) {
      showErrorPopover(input, "You can only add items in increments of ".concat(step, "."));
      disableButtons(true);
    } else {
      hideErrorPopover(input);
      disableButtons(false);
    }
  }

  // Disable or enable buttons based on validation
  function disableButtons(disable) {
    if (addToCartButton) addToCartButton.disabled = disable;
    quantityButtons.forEach(button => button.disabled = disable);
  }
  function showErrorPopover(input, message) {
    var popover = input.parentNode.querySelector(".tooltip");
    if (!popover) {
      popover = document.createElement("div");
      popover.className = "tooltip single-product-select";
      popover.innerHTML = "\n              <div class=\"tooltip__content relative top-[-95px] z-10 mt-2 bg-[--local-pagination-tooltip-background] \n              p-3 border border-[--local-pagination-tooltip-outline] rounded-lg shadow-md text-sm \n              text-[--local-pagination-tooltip-color] tw-flex tw-items-center tw-gap-1.5 tw-justify-center tw-px-[10px] tw-py-2\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\">\n                    <path d=\"M9 6.33765V9.33765M9 15.75C5.27208 15.75 2.25 12.7279 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75ZM9.03735 11.5876V11.6626L8.96265 11.6624V11.5876H9.03735Z\" stroke=\"#FE534C\" strokeLinecap=\"round\" strokeLinejoin=\"round\"/>\n                </svg>\n                <div class=\"text-center tooltip__text\">".concat(message, "</div>\n              </div>\n          ");
      input.parentNode.appendChild(popover);
    }
  }
  function hideErrorPopover(input) {
    var popover = input.parentNode.querySelector(".tooltip");
    if (popover) {
      popover.remove();
    }
  }
});

/***/ }),

/***/ "./js/components/react-wrapper.js":
/*!****************************************!*\
  !*** ./js/components/react-wrapper.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom/client */ "./node_modules/react-dom/client.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_2__);



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((Component, container, propsEl) => {
  //component is a pre-compiled class
  //container is where you want to inject component
  //propEl pass prop when injecting
  var appContainer = document.querySelectorAll(container);
  var singlePropsEl = document.querySelector(propsEl);
  var props = {};
  if (singlePropsEl) {
    props = json_6__WEBPACK_IMPORTED_MODULE_2___default().parse(singlePropsEl === null || singlePropsEl === void 0 ? void 0 : singlePropsEl.innerHTML) || {};
  }
  return [...appContainer].map(appTarget => {
    var initialized = appTarget.dataset.initialized || false;
    if (appTarget && !initialized) {
      if (!singlePropsEl) {
        if (propsEl) {
          var _appTarget$querySelec;
          props = {};
          props = json_6__WEBPACK_IMPORTED_MODULE_2___default().parse((_appTarget$querySelec = appTarget.querySelector(propsEl)) === null || _appTarget$querySelec === void 0 ? void 0 : _appTarget$querySelec.innerHTML) || {}; //get json from the script id 
        }
      }
      appTarget.dataset.initialized = true;
      var root = (0,react_dom_client__WEBPACK_IMPORTED_MODULE_1__.createRoot)(appTarget);
      root.render(/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(Component, {
        shopifyData: props
      }));
      return root;
    }
  });
});

/***/ }),

/***/ "./js/components/react/pdp-variant-selector.js":
/*!*****************************************************!*\
  !*** ./js/components/react/pdp-variant-selector.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _variant_options_selector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./variant-options-selector */ "./js/components/react/variant-options-selector.js");
/* harmony import */ var _product_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../product-api */ "./js/components/product-api.js");



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_ref => {
  var {
    shopifyData
  } = _ref;
  var {
    variantJson
  } = shopifyData;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_variant_options_selector__WEBPACK_IMPORTED_MODULE_1__["default"], {
    variantJson: variantJson,
    footerPlacement: "[react-buybox-footer]"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_product_api__WEBPACK_IMPORTED_MODULE_2__["default"], {
    variantJson: variantJson
  }));
});

/***/ }),

/***/ "./js/components/react/popup-modal.js":
/*!********************************************!*\
  !*** ./js/components/react/popup-modal.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Popup)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function Popup() {
  var [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  var [products, setProduct] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  var updatePopupContent = function updatePopupContent() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    setProduct([...data]);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var handleProductAdded = ev => {
      if (ev.detail.response) {
        updatePopupContent(ev.detail.response.items);
      }
    };
    document.addEventListener('product:added', handleProductAdded);
    return () => document.removeEventListener('product:added', handleProductAdded);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (products !== null && products !== void 0 && products.length) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [products]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (isOpen) {
      setTimeout(() => {
        setProduct(null);
      }, 3000);
    }
  }, [isOpen]);
  return isOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    style: {
      zIndex: 5600
    },
    className: "cart-popup__notification tw-bg-[#FFFFFF] tw-ml-[16px] tw-mr-[16px] md:tw-ml-[0] md:tw-mr-[0] tw-text-white tw-top-[9vh] md:tw-top-[10%] lg:tw-top-[8%] xl:tw-top-[7.5%] tw-fixed tw-z-9999 tw-right-[0] md:tw-right-[13px] tw-mt-2 tw-w-[-webkit-fill-available] md:tw-w-[17.5rem] tw-max-h-60 tw-overflow-auto tw-bg-white tw-border tw-border-[#FE534C] tw-shadow-lg tw-pt-[12px] tw-pl-[12px] tw-pb-[18px] tw-pr-[14px] md:tw-pl-[25px] md:tw-pb-[21px] md:tw-pr-[25px]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
    className: "tw-font-bold tw-flex tw-gap-[10px] tw-items-center tw-mb-[12px]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("g", {
    id: "Warning / Circle_Check"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    id: "Vector",
    d: "M15 10L11 14L9 12M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z",
    stroke: "#FE534C",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "tw-text-[#000] tw-text-[14px] tw-font-[500] tw-capitalize tw-leading-[20px] tw-normal-case"
  }, "Item added to your cart")), products === null || products === void 0 ? void 0 : products.map(product => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "tw-flex tw-justify-between md:tw-flex-col"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "tw-text-[#000] tw-text-[16px] tw-font-[500] tw-leading-[24px] tw-mb-[4px]"
    }, product === null || product === void 0 ? void 0 : product.title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "tw-text-[#000] tw-text-[16px] tw-font-[500] tw-leading-[24px]"
    }, "$", (product === null || product === void 0 ? void 0 : product.price) / 100));
  }));
}

/***/ }),

/***/ "./js/components/react/variant-drawer.js":
/*!***********************************************!*\
  !*** ./js/components/react/variant-drawer.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @headlessui/react */ "./node_modules/@headlessui/react/dist/components/dialog/dialog.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _variant_options_selector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./variant-options-selector */ "./js/components/react/variant-options-selector.js");
/* harmony import */ var _popup_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./popup-modal */ "./js/components/react/popup-modal.js");





var ProductVariantDrawer = () => {
  var [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var [variantJson, setVariantJson] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
  var updateContent = /*#__PURE__*/function () {
    var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (handle) {
      setIsOpen(false);
      var data = yield fetch("".concat(Shopify.routes.root, "products/").concat(handle, "?view=variants-data"));
      var dataRes = yield data.json();
      setVariantJson(dataRes);
    });
    return function updateContent(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (variantJson) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [variantJson]);
  var handleClose = () => {
    setVariantJson(null);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    window.updateVariantData = updateContent;
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__.Dialog, {
    open: isOpen,
    transition: true,
    onClose: handleClose,
    className: "tw-relative tw-z-50 tw-transition tw-duration-300 tw-ease-out"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__.DialogBackdrop, {
    transition: true,
    className: "tw-fixed tw-inset-0 tw-bg-black/30 tw-duration-300 tw-ease-out"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-fixed tw-inset-x-0 tw-bottom-0 tw-flex tw-justify-center tw-max-h-[597px] lg:tw-max-h-[463px]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__.DialogPanel, {
    className: "tw-w-full tw-bg-white tw-shadow-lg tw-transition-all tw-duration-500 tw-ease-in-out tw-delay-200 ".concat(isOpen ? "tw-translate-y-0 tw-opacity-100" : "tw-translate-y-full tw-opacity-0")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-space-y-4"
  }, variantJson && variantJson.length > 0 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_variant_options_selector__WEBPACK_IMPORTED_MODULE_3__["default"], {
    variantJson: variantJson,
    handleClose: handleClose
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("p", null, "Loading..."))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_popup_modal__WEBPACK_IMPORTED_MODULE_4__["default"], null));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductVariantDrawer);

/***/ }),

/***/ "./js/components/react/variant-options-selector.js":
/*!*********************************************************!*\
  !*** ./js/components/react/variant-options-selector.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _variant_selector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./variant-selector */ "./js/components/react/variant-selector.js");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react-dom */ "./node_modules/react-dom/index.js");


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_ref => {
  var {
    variantJson,
    footerPlacement = false,
    handleClose
  } = _ref;
  var [selectedVariants, setSelectedVariants] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
  var totalSelectedQuantity = selectedVariants.reduce((total, variant) => total + variant.selectedQuantity, 0);
  var [isError, setIsError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
  var updateError = _ref2 => {
    var {
      id,
      flag
    } = _ref2;
    var errorFlags = JSON.parse(JSON.stringify(isError));
    if (flag) {
      if (!errorFlags[id]) {
        errorFlags[id] = true;
      }
    } else {
      if (errorFlags[id]) {
        delete errorFlags[id];
      }
    }
    setIsError(_objectSpread({}, errorFlags));
  };
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var updateFooterHeight = () => {
      var footerEl = document.querySelector('[pdp-floating-element="true"]');
      if (footerEl) {
        var height = footerEl.clientHeight;
        document.documentElement.style.setProperty("--pdp-floating-element", "".concat(height, "px"));
      }
    };
    updateFooterHeight();
    window.addEventListener("resize", updateFooterHeight);
    return () => window.removeEventListener("resize", updateFooterHeight);
  }, []);
  var handleAddToCart = /*#__PURE__*/function () {
    var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (ev) {
      ev.preventDefault();
      var products = selectedVariants.map(variant => {
        return {
          id: variant.id,
          quantity: variant.selectedQuantity,
          properties: {
            _quantity: variant.quantity
          }
        };
      });
      var formData = {
        'items': products
      };
      var cartRes = yield fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      var resJson = yield cartRes.json();
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
        bubbles: true
      }));
      document.dispatchEvent(new CustomEvent('product:added', {
        detail: {
          response: resJson
        },
        bubbles: true
      }));
      handleClose();
    });
    return function handleAddToCart(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var updateSelectedVariants = variant => {
    var isAlreadySelected = false;
    var deepClonedSelectedVariants = JSON.parse(JSON.stringify(selectedVariants));
    deepClonedSelectedVariants.forEach(selectedVariant => {
      if (variant.id == selectedVariant.id) {
        selectedVariant["selectedQuantity"] = variant.selectedQuantity;
        isAlreadySelected = true;
      }
    });
    if (!isAlreadySelected) {
      deepClonedSelectedVariants = [...deepClonedSelectedVariants, variant];
    }
    deepClonedSelectedVariants = deepClonedSelectedVariants.filter(variant => variant.selectedQuantity != 0);
    setSelectedVariants([...deepClonedSelectedVariants]);
  };
  var FooterEl = () => {
    var totalPrice = selectedVariants.reduce((total, variant) => total + parseFloat((variant.price.raw_price * variant.selectedQuantity).toFixed(2)), 0);
    var formattedPrice = totalPrice.toFixed(2);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      "pdp-floating-element": handleClose ? "false" : "true",
      className: "tw-mt-4 tw-bg-red-500 tw-text-white tw-flex tw-justify-between tw-items-center tw-px-[18px] tw-py-[16px] lg:tw-px-[64px] lg:tw-py-[13px] tw-m-0 !tw-mt-0 tw-flex-col lg:tw-flex-row tw-gap-[10px] lg:tw-gap-[28px] ".concat(handleClose ? "" : "tw-fixed tw-bottom-0 tw-w-full tw-z-[99]")
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "tw-flex tw-justify-between tw-w-[100%]"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
      className: "tw-font-[600] tw-leading-[21.18px]"
    }, totalSelectedQuantity, " items selected"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
      className: "tw-font-[600] tw-leading-[21.18px]"
    }, "Total - $", formattedPrice)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
      disabled: selectedVariants.length === 0 || Object.keys(isError).length > 0,
      className: "".concat(selectedVariants.length > 0 ? 'tw-bg-white tw-text-[#FE534C]' : 'tw-text-[#FE534C] tw-bg-red-300', " tw-text-[15px] tw-font-[500] tw-px-4 tw-py-2 tw-rounded tw-w-[100%] lg:tw-w-[165px] tw-h-[39px] tw-rounded-full"),
      onClick: handleAddToCart
    }, "ADD TO CART"));
  };
  var renderFooterEl = () => {
    if (footerPlacement) {
      var el = document.querySelector(footerPlacement);
      if (el) {
        return /*#__PURE__*/(0,react_dom__WEBPACK_IMPORTED_MODULE_3__.createPortal)(FooterEl(), document.querySelector(footerPlacement));
      }
    } else {
      return FooterEl();
    }
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-mb-[20px]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "grey-border tw-flex tw-items-center !tw-border tw-py-[12px] lg:tw-py-[16px] !tw-border-[#CACACA] ".concat(handleClose ? "tw-pl-[55px] tw-pr-[18px] lg:tw-px-[64px]" : "tw-px-[18px] lg:tw-px-[21px]")
  }, variantJson.length > 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-text-[18px] tw-font-[500] tw-leading-[21.18px] ".concat(handleClose ? "tw-w-[50%] lg:tw-w-[40%]" : "tw-w-[50%] lg:tw-w-[40%]")
  }, "Variant"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-text-[18px] tw-font-[500] tw-leading-[21.18px] ".concat(handleClose ? "tw-w-[35%] tw-hidden lg:tw-block" : variantJson.length > 1 ? "tw-w-[25%] tw-hidden lg:tw-block" : "tw-w-[50%] lg:tw-w-[33%] tw-block")
  }, "Price"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-text-[18px] tw-font-[500] tw-hidden lg:tw-block tw-leading-[21.18px] ".concat(handleClose ? "tw-w-[10%]" : variantJson.length > 1 ? "tw-w-[15%]" : "tw-w-[33%]")
  }, "Qty"), variantJson.length && variantJson.length > 1 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-text-right hhhhhhh tw-text-[18px] tw-font-[500] tw-leading-[21.18px] ".concat(handleClose ? "tw-w-[50%] lg:tw-w-[15%]" : variantJson.length > 1 ? "tw-w-[50%] lg:tw-w-[20%]" : "tw-w-[50%] lg:tw-w-[33%]")
  }, "Variant Total") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-text-right hhhhhhh tw-text-[18px] tw-font-[500] tw-leading-[21.18px] ".concat(handleClose ? "tw-w-[50%] lg:tw-w-[15%]" : variantJson.length > 1 ? "tw-w-[50%] lg:tw-w-[20%]" : "tw-w-[50%] lg:tw-w-[33%]")
  }, "Total"), handleClose && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
    onClick: handleClose,
    className: "tw-absolute tw-left-[18px] lg:tw-left-[unset] lg:tw-right-2 2xl:tw-right-0 tw-text-gray-500 hover:tw-text-gray-700 tw-w-[3%]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
    d: "M16.9409 7.05859L7.05859 16.9409",
    stroke: "black",
    strokeWidth: "1.21008"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("rect", {
    x: "0.352941",
    y: "0.352941",
    width: "23.2941",
    height: "23.2941",
    rx: "11.6471",
    stroke: "black",
    strokeWidth: "0.705882"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
    d: "M7.05905 7.05859L16.9414 16.9409",
    stroke: "black",
    strokeWidth: "1.21008"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "".concat(handleClose ? "tw-h-full tw-max-h-[341px] tw-overflow-y-auto" : "tw-overflow-y-visible border-right border-left border-bottom")
  }, variantJson.map((variant, index) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_variant_selector__WEBPACK_IMPORTED_MODULE_4__["default"], {
    key: index,
    variant: variant,
    setSelectedVariants: updateSelectedVariants,
    handleClose: handleClose,
    updateError: updateError
  }))), renderFooterEl());
});

/***/ }),

/***/ "./js/components/react/variant-selector.js":
/*!*************************************************!*\
  !*** ./js/components/react/variant-selector.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @headlessui/react */ "./node_modules/@headlessui/react/dist/components/popover/popover.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_ref => {
  var {
    variant,
    setSelectedVariants,
    handleClose,
    updateError
  } = _ref;
  var [quantity, setQuantity] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(variant.quantity.min);
  var [inputQuantity, setInputQuantity] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(variant.quantity.min);
  var [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    updateError({
      id: variant.id,
      flag: error
    });
  }, [error]);
  var handleIncrease = () => {
    var step = Number(variant.quantity.increment) || 1;
    var newQuantity = (quantity || 0) + step;
    setQuantity(newQuantity);
    validateQuantity(newQuantity);
  };
  var handleDecrease = () => {
    var step = Number(variant.quantity.increment) || 1;
    var newQuantity = Math.max((quantity || variant.quantity.min) - step, variant.quantity.min);
    setQuantity(newQuantity);
    validateQuantity(newQuantity);
  };
  var handleInputChange = e => {
    var value = Number(e.target.value);
    if (isNaN(value) || value < 0) {
      setInputQuantity(variant.quantity.min);
      return;
    }
    setInputQuantity(value);
    validateQuantity(value);
  };
  var validateQuantity = value => {
    if (value % variant.quantity.increment !== 0) {
      var errorMsg = "You can only add items in increments of ".concat(variant.quantity.increment);
      setError(errorMsg);
    } else {
      setError("");
    }
  };
  var calculateTotalPrice = (quantity, price) => {
    var cleanPrice = parseFloat(price === null || price === void 0 ? void 0 : price.toString().replace("$", "").replace("--srp", "")) || 0;
    return "$".concat(quantity > 0 ? (quantity * cleanPrice).toFixed(2) : "0");
  };
  function AlwaysOpenPopover() {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__.Popover, {
      className: "tooltip ".concat(handleClose ? "inline-element" : "floating-element")
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "w-[168px] tooltip__content relative top-[-95px] z-10 mt-2 bg-[--local-pagination-tooltip-background] p-3 border border-[--local-pagination-tooltip-outline] rounded-lg shadow-md text-sm text-[--local-pagination-tooltip-color] tw-flex tw-items-center tw-gap-1.5"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
      d: "M9 6.33765V9.33765M9 15.75C5.27208 15.75 2.25 12.7279 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75ZM9.03735 11.5876V11.6626L8.96265 11.6624V11.5876H9.03735Z",
      stroke: "#FE534C",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "text-center tooltip__text"
    }, error)));
  }
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    setSelectedVariants(_objectSpread(_objectSpread({}, variant), {}, {
      selectedQuantity: quantity
    }));
  }, [quantity]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (quantity != inputQuantity) {
      setQuantity(inputQuantity);
    }
  }, [inputQuantity, quantity]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-px-[18px] ".concat(handleClose ? "lg:tw-px-[64px]" : "lg:tw-px-[21px]")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    key: variant.id,
    className: "border-bottom tw-pt-[10px] tw-pb-[16px] tw-flex tw-items-center lg:tw-py-[10px] tw-flex-col lg:tw-flex-row"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: " tw-flex lg:tw-items-center tw-justify-start lg:justify-between tw-items-start ".concat(variant.title === "Default Title" ? "lg:tw-hidden tw-block" : "tw-w-[100%] lg:tw-w-[40%]")
  }, variant.title != "Default Title" && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("img", {
    src: variant.image.src,
    alt: variant.title,
    className: "grey-border tw-max-w-[57px] tw-w-[100%] tw-h-[57px]"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-flex tw-w-full tw-gap-[10px] ".concat(handleClose ? "tw-mx-[17px] lg:tw-mx-[29px] tw-flex-col" : variant.title === "Default Title" ? "tw-flex-row" : "tw-flex-col tw-mx-[14px]")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-text-[12px] tw-font-[500] tw-text-[#666] ".concat(variant.title === "Default Title" ? "tw-hidden" : "tw-block")
  }, "SKU: ", variant.sku), variant.title != "Default Title" && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-text-[16px] tw-font-[500] tw-uppercase tw-line-clamp-2"
  }, variant.title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "lg:tw-w-[38%] lg:tw-hidden tw-block tw-basis-1/2 md:tw-basis-[65%]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-text-[16px] tw-font-[500] tw-flex tw-gap-[10px] srp-comapre__price-b2b"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "tw-font-[600] tw-flex tw-gap-[4px]"
  }, "SRP: ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    "data-srp-price-b2b": true,
    className: ""
  }, variant.price.srp))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "tw-text-[#000] tw-flex tw-gap-[4px] special-price__hide"
  }, " Special: ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    "data-compare-price-b2b": true,
    className: "tw-font-[600] srp-comapre__price-b2b-color"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-text-[16px] tw-font-[500]"
  }, "Cost: ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    "data-cost-price-b2b": true,
    className: "tw-font-[600]"
  }, variant.price.cost))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-flex lg:tw-hidden tw-justify-between tw-items-center tw-pt-[7px]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "grey-border tw-relative lg:tw-w-[41%] tw-w-[47%] md:tw-w-[52%]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("quantity-counter", {
    clasName: "quantity-selector"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    disabled: error,
    className: "quantity__minus ".concat(handleClose ? "tw-pl-[15px]" : "tw-pl-[5px]"),
    type: "button",
    name: "decrease",
    onClick: () => handleDecrease(variant)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    role: "presentation",
    className: "icon icon-minus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
    d: "M6 12h12",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("input", {
    className: "quantity__input tw-border-none tw-py-[6px]",
    type: "number",
    name: "quantity",
    value: quantity,
    min: variant.quantity.min,
    step: variant.quantity.increment,
    "aria-label": "quantity",
    autoComplete: "off",
    onChange: handleInputChange,
    "data-popout-input": true
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    disabled: error,
    className: "quantity__plus ".concat(handleClose ? "tw-pr-[15px]" : "tw-pr-[5px]"),
    type: "button",
    name: "increase",
    onClick: () => handleIncrease(variant)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    role: "presentation",
    className: "icon icon-plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
    d: "M6 12h6m6 0h-6m0 0V6m0 6v6",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(AlwaysOpenPopover, null)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-text-right tw-font-[600] tw-text-[20px] lg:tw-text-[16px]"
  }, calculateTotalPrice(quantity, variant.price.cost))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-hidden lg:tw-flex lg:tw-basis-[43%] ".concat(handleClose ? "tw-w-[35%] tw-gap-[20px]" : variant.title === "Default Title" ? "tw-w-[33%] tw-flex-col" : "tw-w-[25%] tw-flex-col")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-text-[16px] tw-font-[500] tw-flex tw-gap-[10px] srp-comapre__price-b2b"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "tw-font-[600] tw-flex tw-gap-[4px]"
  }, "SRP: ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    "data-srp-price-b2b": true,
    className: ""
  }, variant.price.srp))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "tw-text-[#000] tw-flex tw-gap-[4px] special-price__hide"
  }, " Special: ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    "data-compare-price-b2b": true,
    className: "tw-font-[600] srp-comapre__price-b2b-color"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-text-[16px] tw-font-[500]"
  }, "Cost: ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    "data-cost-price-b2b": true,
    className: "tw-font-[600]"
  }, variant.price.cost))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "grey-border tw-relative tw-hidden lg:tw-block ".concat(handleClose ? "lg:tw-w-[10%]" : variant.title === "Default Title" ? "lg:tw-w-[33%]" : "lg:tw-w-[15%]")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("quantity-counter", {
    clasName: "quantity-selector"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    disabled: error,
    className: "quantity__minus ".concat(handleClose ? "tw-pl-[15px]" : "tw-pl-[5px]"),
    type: "button",
    name: "decrease",
    onClick: () => handleDecrease(variant)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    role: "presentation",
    className: "icon icon-minus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
    d: "M6 12h12",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("input", {
    className: "quantity__input tw-border-none tw-py-[6px]",
    type: "number",
    name: "quantity",
    value: quantity,
    min: variant.quantity.min,
    step: variant.quantity.increment,
    "aria-label": "quantity",
    autoComplete: "off",
    onChange: handleInputChange,
    "data-popout-input": true
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    disabled: error,
    className: "quantity__plus ".concat(handleClose ? "tw-pr-[15px]" : "tw-pr-[5px]"),
    type: "button",
    name: "increase",
    onClick: () => handleIncrease(variant)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    role: "presentation",
    className: "icon icon-plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
    d: "M6 12h6m6 0h-6m0 0V6m0 6v6",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(AlwaysOpenPopover, null)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-text-right tw-text-[16px] tw-font-[600] tw-hidden jjjjj lg:tw-block ".concat(handleClose ? "tw-w-[15%]" : variant.title === "Default Title" ? "tw-w-[33%]" : "tw-w-[20%]")
  }, calculateTotalPrice(quantity, variant.price.cost))));
});

/***/ }),

/***/ "./js/sections/global.js":
/*!*******************************!*\
  !*** ./js/sections/global.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! JsComponents/react-wrapper */ "./js/components/react-wrapper.js");
/* harmony import */ var ReactComponents_variant_drawer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ReactComponents/variant-drawer */ "./js/components/react/variant-drawer.js");
/* harmony import */ var ReactComponents_pdp_variant_selector__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ReactComponents/pdp-variant-selector */ "./js/components/react/pdp-variant-selector.js");
/* harmony import */ var JsComponents_quantity_rule_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! JsComponents/quantity-rule-error */ "./js/components/quantity-rule-error.js");
/* harmony import */ var JsComponents_product_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! JsComponents/product-api */ "./js/components/product-api.js");





document.addEventListener('DOMContentLoaded', () => {
  (0,JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(ReactComponents_variant_drawer__WEBPACK_IMPORTED_MODULE_1__["default"], 'react-drawer', ' #react-drawer');
  (0,JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(ReactComponents_pdp_variant_selector__WEBPACK_IMPORTED_MODULE_2__["default"], 'pdp-variant-selector', ' #pdp-variant-selector');
  (0,JsComponents_quantity_rule_error__WEBPACK_IMPORTED_MODULE_3__["default"])();
  (0,JsComponents_product_api__WEBPACK_IMPORTED_MODULE_4__["default"])();
});
document.addEventListener('section:reloaded', () => {
  (0,JsComponents_product_api__WEBPACK_IMPORTED_MODULE_4__["default"])();
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"global": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors"], () => (__webpack_require__("./js/sections/global.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;